import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { QuestionsVM, QuestionTypes, TrainingSlidesVM } from '../setup-training-types.model';
import { TrainingService } from '../training.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-training-question',
  templateUrl: './add-training-question.component.html',
  styleUrls: ['./add-training-question.component.scss']
})
export class AddTrainingQuestionComponent implements OnInit {
  isAddQuestion: boolean = false;

  QTitle: string;
  QDescription: string;
  questionTypeId: number;
  QuestionTypes: QuestionTypes[] = [];

  SlideId: number;
  SlideList: TrainingSlidesVM[];

  RadioTrueFalse: number = 0;
  optionupdate: boolean = false;
  AnswerOptions: any[];
  Option: string;
  correctAnswerCount: number;
  validateOptions: boolean = false;
  SectionId: number;
  TrainingId: number

  isEditQuestion:boolean=false;
  SelectedQuestionInfo:QuestionsVM;
  constructor(
    public _dialogRef: MatDialogRef<AddTrainingQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _notify: NotificationsService,
    private _trainingService: TrainingService,
    private ref: ChangeDetectorRef,
    private _sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.isAddQuestion = this.data.isAddQuestion;
    this.QuestionTypes = this.data.QuestionTypes;
    this.SlideList = this.data.Slides;
    this.SectionId = this.data.SectionId;
    this.TrainingId = this.data.TrainingId;
    this.isEditQuestion = this.data.isEditQuestion;
    this.SelectedQuestionInfo=this.data.SelectedQuestionInfo;

    if(this.isEditQuestion==true){
      this.QTitle=this.SelectedQuestionInfo.QuestionName;
      this.SlideId=this.SelectedQuestionInfo.SlideId;
      this.correctAnswerCount = this.SelectedQuestionInfo.AnswerCount;
      this.questionTypeId=this.SelectedQuestionInfo.QuestionTypeId;
      if(this.questionTypeId==2 || this.questionTypeId==3){
        this.AnswerOptions=this.SelectedQuestionInfo.AnswerList;
      }
     if(this.questionTypeId==1){
      this.AnswerOptions=this.SelectedQuestionInfo.AnswerList;
       this.AnswerOptions.map(x=>{
         if(x.Select==true){
           this.RadioTrueFalse= x.Name=="True"?1:2;
         }
       })
     }

    }
  }
  ChangeOption() {
    this.AnswerOptions = null;
    this.validateOptions = false;
  }
  AddAnswerOption() {
    this.optionupdate = true;
    console.log("Options", this.AnswerOptions)
    let arr_ = [];
    if (this.AnswerOptions == null) {

      var object = {
        Id: 1,
        Name: this.Option,
        Select: false,
      }
      arr_.push(object);
      this.Option = "";
      this.AnswerOptions = arr_;

    } else {

      let count = this.AnswerOptions.length + 1;
      var obj = {
        Id: count,
        Name: this.Option,
        Select: false
      }
      this.Option = "";
      this.AnswerOptions.push(obj);
    }
  }
  selectAnswerRadio(AnswerId: number) {
    this.AnswerOptions.map(x => {
      if (x.Id == AnswerId) {
        x.Select = true;
      } else {
        x.Select = false;
      }
    })
  }
  selectAnswer(AnswerId: number, status: boolean) {
    let count = 0;
    this.AnswerOptions.map(x => {
      if (x.Id == AnswerId) {
        x.Select = status;
      }
      if (x.Select == true) {
        count = count + 1;
      }
    })

    if (count < this.correctAnswerCount) {
      this.validateOptions = true;
    } else {
      this.validateOptions = false;
    }
  }

  RemoveAnswerOption(Id: number) {
    this.optionupdate = true;
    console.log("Id", Id)
    this.AnswerOptions = this.AnswerOptions.filter(x => x.Id != Id);
  }

  validateAnswerCount() {
    let count = 0;
    if (this.questionTypeId == 3) {
      this.AnswerOptions.map(x => {
        if (x.Select == true) {
          count = count + 1;
        }
      })
      console.log("count", count)
      if (count < this.correctAnswerCount) {
        this.validateOptions = true;
      } else {
        this.validateOptions = false;
      }
    }
  }

  onNoClick() {
    this._dialogRef.close(false);
  }
  SelectAnswerTrueFalse(){
    console.log("this.RadioTrueFalse", this.RadioTrueFalse)
    this.AnswerOptions = null;
    console.log("this.AnswerOptions", this.AnswerOptions)
  }
  onAddQuestion() {
    let q = new QuestionsVM();
    q.QuestionName = this.QTitle;
    q.SlideId = this.SlideId;
    q.QuestionTypeId = this.questionTypeId;
    q.SubSectionId = this.SectionId;
    q.TrainingId = this.TrainingId;
    q.AnswerCount = this.correctAnswerCount;
    if (Number(this.questionTypeId) == 1) {

      let arr_ = [];
      if (this.AnswerOptions == null) {
        console.log("this.RadioTrueFalse", this.RadioTrueFalse)
        var obj = {
          Id: 1,
          Name: "True",
          Select: Number(this.RadioTrueFalse)==1 ? true : false,
        }
        arr_.push(obj);


        var obj_ = {
          Id: 2,
          Name: "False",
          Select: Number(this.RadioTrueFalse) == 2 ? true : false,
        }
        arr_.push(obj_);
        this.AnswerOptions = arr_;
        q.AnswerList = this.AnswerOptions;
      }
    }else{
      q.AnswerList = this.AnswerOptions;
    }
   
    this._trainingService.CreateNewTrainingQuestion(q).subscribe(res=>{
      if (res == true) {
        this._notify.success('Saved', 'New Question Created');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Create Question');
      }
    })
  
    console.log("Question details", q)

  }

  onEditQuestion(){
    let q = new QuestionsVM();
    q.QuestionId = this.SelectedQuestionInfo.QuestionId;
    q.QuestionName = this.QTitle;
    q.SlideId = this.SlideId;
    q.QuestionTypeId = this.questionTypeId;
    q.SubSectionId = this.SectionId;
    q.TrainingId = this.TrainingId;
    q.AnswerCount = this.correctAnswerCount;
    if (Number(this.questionTypeId) == 1) {

      let arr_ = [];
      if (this.AnswerOptions == null) {
        console.log("this.RadioTrueFalse", this.RadioTrueFalse)
        var obj = {
          Id: 1,
          Name: "True",
          Select: Number(this.RadioTrueFalse)==1 ? true : false,
        }
        arr_.push(obj);


        var obj_ = {
          Id: 2,
          Name: "False",
          Select: Number(this.RadioTrueFalse) == 2 ? true : false,
        }
        arr_.push(obj_);
        this.AnswerOptions = arr_;
        q.AnswerList = this.AnswerOptions;
      }
    }else{
      q.AnswerList = this.AnswerOptions;
    }
   
    this._trainingService.UpdateTrainingQuestion(q).subscribe(res=>{
      if (res == true) {
        this._notify.success('Saved', 'Successfully Updated Question');
        this._dialogRef.close(true)
      } else {
        this._notify.error('Failed', 'Failed to Update Question');
      }
    })
  
    console.log("Question details", q)
  }

}
